const LOGIN_INFO = 'WP_LOGIN_INFO';
const WARD_INFO = 'WP_WARD_INFO';
const DUTY_INFO = 'DUTY_ASSIGN_INFO_';
const IS_LOGIN_ACTION = 'IS_LOGIN_ACTION';
const SETTING_TAB_ACTION_ID = 'SETTING_TAB_ACTION_ID';
const BEDSTATUS_CHOOSE_FILTER = 'BEDSTATUS_CHOOSE_FILTER';
const IS_TOKEN_ERROR_ALTER = 'IS_TOKEN_ERROR_ALTER';
const REFRESH_TOKEN_MINUTE = 60;
export const ACCESS_TOKEN_MINUTE = 5;
export const DWP_UPDATE_LOGIN_INFO = 'DWP_UPDATE_LOGIN_INFO';
// common
const USER_CURRENT_LANG = 'USER_CURRENT_LANG';
const SETTING_EDIT_TABLE = 'SETTING_EDIT_TABLE';
const NOTIFICATION_TAB = 'NOTIFICATION_TAB';
const NOTIFICATION_MESSAGE = 'NOTIFICATION_MESSAGE';
const BEDSTATUS_OUTSTANDING_TRANSFER_IN = 'BEDSTATUS_OUTSTANDING_TRANSFER_IN';

// header notification 紅點API刷新間隔
const NOTIFICATION_INTERVAL = 10 * 60 * 1000;

// header appreciation refresh interval
const APPRECIATION_INTERVAL = 10 * 60 * 1000;

// equipment module 刷新間隔
const EQUIPMENT_INTERVAL = 1000 * 30;

const CHECK_TOKEN_EXPIRY_INTERVAL = 60 * 60 * 1000;

// request status 的枚舉
const REQUEST_STATUS_ENUM = {
  PENDING: {
    enumKey: 1,
    color: '#ffc95c',
    textKey: 'EQUIPMENT_REQUEST_STATUS_PENDING',
  },
  LOANED: {
    enumKey: 2,
    color: '#34c759',
    textKey: 'EQUIPMENT_REQUEST_STATUS_LOANED',
  },
  DECLINED: {
    enumKey: 3,
    color: '#c0c6cb',
    textKey: 'EQUIPMENT_REQUEST_STATUS_DECLINED',
  },
  RETURNED: {
    enumKey: 4,
    color: '#538fff',
    textKey: 'EQUIPMENT_REQUEST_STATUS_RETURNED',
  },
  WITHDRAWN: {
    enumKey: 5,
    color: '#FF7270',
    textKey: 'EQUIPMENT_REQUEST_STATUS_WITHDRAWN',
  },
  TRANSFER: {
    enumKey: 6,
    color: '#7524ff',
    textKey: 'EQUIPMENT_REQUEST_STATUS_TRANFER',
  },
  TRANSFER_FULFILLED: {
    enumKey: -1,
    color: '#34c759',
    textKey: 'EQUIPMENT_REQUEST_STATUS_TRANFER_FULLFILED',
  },
  TRANSFER_RETURNED: {
    enumKey: -2,
    color: '#548EED',
    textKey: 'EQUIPMENT_REQUEST_STATUS_TRANSFER_RETURNED',
  },
};

// 餅圖 equipment status 的枚舉
// #538fff,  #b431e6,  #ff5b58,  #f7ed65,  #28d2ab,  #fca207,  #f6ccf9,  #268189 , #2d1a77.
const EQUIPMENT_PIE_STATUS_ENUM = {
  AVAILABLE: {
    enumKey: 1,
    color: '#538fff',
    textKey: 'EQUIPMENT_STATUS_AVAILABLE',
  },
  ONLOAN: {
    enumKey: 2,
    color: '#b431e6',
    textKey: 'EQUIPMENT_STATUS_ONLOAN',
  },
  STANDBY: {
    enumKey: 3,
    color: '#ff5b58',
    textKey: 'EQUIPMENT_STATUS_STANDBY',
  },
  INUSE: {
    enumKey: 4,
    color: ' #f7ed65',
    textKey: 'EQUIPMENT_STATUS_INUSE',
  },
  RETURNING: {
    enumKey: 5,
    color: '#28d2ab',
    textKey: 'EQUIPMENT_STATUS_RETURNING',
  },
  NOTFORLOAN: {
    enumKey: 6,
    color: '#fca207',
    textKey: 'EQUIPMENT_STATUS_NOTFORLOAN',
  },
  REPAIRING: {
    enumKey: 7,
    color: '#f6ccf9',
    textKey: 'EQUIPMENT_STATUS_REPAIRING',
  },
  RESERVED: {
    enumKey: 8,
    color: '#268189',
    textKey: 'EQUIPMENT_STATUS_RESERVED',
  },
  CONDEMNED: {
    enumKey: 9,
    color: '#2d1a77',
    textKey: 'EQUIPMENT_STATUS_CONDEMNED',
  },
  REPROCESSING: {
    enumKey: 10,
    color: '#34c759',
    textKey: 'EQUIPMENT_STATUS_REPROCESSING',
  },
};

// equipment status 的枚舉
const EQUIPMENT_STATUS_ENUM = {
  AVAILABLE: {
    enumKey: 1,
    color: '#34c759',
    textKey: 'EQUIPMENT_STATUS_AVAILABLE',
  },
  ONLOAN: {
    enumKey: 2,
    color: '#ffc95c',
    textKey: 'EQUIPMENT_STATUS_ONLOAN',
  },
  STANDBY: {
    enumKey: 3,
    color: '#ffc95c',
    textKey: 'EQUIPMENT_STATUS_STANDBY',
  },
  INUSE: {
    enumKey: 4,
    color: '#ffc95c',
    textKey: 'EQUIPMENT_STATUS_INUSE',
  },
  RETURNING: {
    enumKey: 5,
    color: '#ffc95c',
    textKey: 'EQUIPMENT_STATUS_RETURNING',
  },
  NOTFORLOAN: {
    enumKey: 6,
    color: '#ff7270',
    textKey: 'EQUIPMENT_STATUS_NOTFORLOAN',
  },
  REPAIRING: {
    enumKey: 7,
    color: '#ff7270',
    textKey: 'EQUIPMENT_STATUS_REPAIRING',
  },
  RESERVED: {
    enumKey: 8,
    color: '#ff7270',
    textKey: 'EQUIPMENT_STATUS_RESERVED',
  },
  CONDEMNED: {
    enumKey: 9,
    color: '#ff7270',
    textKey: 'EQUIPMENT_STATUS_CONDEMNED',
  },
  REPROCESSING: {
    enumKey: 10,
    color: '#2d1a77',
    textKey: 'EQUIPMENT_STATUS_REPROCESSING',
  },
};

// update request date format
const EQUIPMENT_REQUEST_DATE_FORMAT = 'yyyy-MM-DD HH:mm';

// text length
const EQUIPMENT_LENGTH = {
  REQUEST_HN: 50,
  REQUEST_BED: 10,
  REQUEST_REMARK: 100,
  EQUIPMENT_ASSET: 10,
  EQUIPMENT_REMARK: 100,
};

const SERVICE = {
  TIME_REGEX: /\d{2}:\d{2}/,
  MAX_TIME_HOURS: 24,
  MAX_TIME_MINUTE: 60,
};

const BOOKING_DETAILS = {
  SCHEDULED_BOOKING: 'scheduledBooking',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  CANCELED_BOOKING: 'cancelBooking',
  VERIFYING_BOOKING: 'verifyingBooking',
  INPROGRESS_BOOKING: 'INPROGRESS_BOOKING',
  URGENT_BOOK: 'adHocBooking',
};

const TELEVISIT_ROBOT_STATUS = {
  UNAVAILABLE: 0,
  AVAILABLE: 1,
};

const TELEVISIT_STATUS = {
  UNAVAILABLE: 0,
  AVAILABLE: 1,
  RESERVED: 2,
  CONFIRMED: 3,
  INPROGRESS: 4,
  COMPLETED: 5,
  REJECTED: 6,
  CANCEL: 7,
  ROBOT_START_PROCESSING_BOOKING: 8,
  COMPLETED_MANUALLY: 9,
  URGENT_BOOK: 10,
  ROBOT_UNAVAILABLE: 100,
  ROBOT_UNAVAILABLE_TIMEOUT: 101,
  ADHOC_CONFIRMED: 1010,
};

const TELEVISIT_STYLE = {
  [TELEVISIT_STATUS.UNAVAILABLE]: {
    leftColor: '#5f5f5f',
    bgColor: '#e0e0e0',
    border: 'unset',
    color: '#666666',
  },
  [TELEVISIT_STATUS.AVAILABLE]: {
    leftColor: '#e4e7eb',
    bgColor: '#fff',
    border: 'solid 1.5px #eeeeee',
    color: '#333333',
  },
  [TELEVISIT_STATUS.RESERVED]: {
    leftColor: '#6C2AF8',
    bgColor: '#DECFFF',
    border: 'unset',
    color: '#6C2AF8',
  },
  [TELEVISIT_STATUS.CONFIRMED]: {
    leftColor: '#538fff',
    bgColor: '#bad2ff',
    border: 'unset',
    color: '#32579e',
  },
  [TELEVISIT_STATUS.ADHOC_CONFIRMED]: {
    leftColor: '#ffff66',
    bgColor: '#bad2ff',
    border: 'unset',
    color: '#32579e',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  [TELEVISIT_STATUS.INPROGRESS]: {
    leftColor: '#28d2ab',
    bgColor: '#a9eddd',
    border: 'unset',
    color: '#1f846d',
  },
  [TELEVISIT_STATUS.COMPLETED]: {
    leftColor: '#c4d6f8',
    bgColor: '#e3eaf8',
    border: 'unset',
    color: 'rgba(50, 87, 158,0.5)',
  },
  [TELEVISIT_STATUS.ADHOC_COMPLETED]: {
    leftColor: '#ffff66',
    bgColor: '#e3eaf8',
    border: 'unset',
    color: 'rgba(50, 87, 158,0.5)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  [TELEVISIT_STATUS.COMPLETED_MANUALLY]: {
    leftColor: '#c4d6f8',
    bgColor: '#e3eaf8',
    border: 'unset',
    color: 'rgba(50, 87, 158,0.5)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  [TELEVISIT_STATUS.URGENT_BOOK]: {
    leftColor: 'rgba(228, 231, 235,0.1)',
    bgColor: 'rgba(255, 255, 255,0.1)',
    border: 'solid 1.5px rgba(238, 238, 238,0.1)',
    color: 'rgba(51, 51, 51,0.1)',
  },
  [TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING]: {
    leftColor: '#538fff',
    bgColor: '#bad2ff',
    border: 'unset',
    color: '#32579e',
  },
  [TELEVISIT_STATUS.ROBOT_UNAVAILABLE]: {
    leftColor: '#5f5f5f',
    bgColor: '#e0e0e0',
    border: 'unset',
    color: '#666666',
    backgroundSize: '100% 100%',
    unavailable: true,
  },
  [TELEVISIT_STATUS.ROBOT_UNAVAILABLE_TIMEOUT]: {
    leftColor: 'rgba(95, 95, 95, 0.3)',
    bgColor: '#e0e0e0',
    border: 'unset',
    color: 'rgba(95, 95, 95, 0.3)',
    backgroundPosition: '0.5rem 0px',
    backgroundSize: 'calc(100% - 0.5rem) 100%',
    backgroundRepeat: 'repeat-y',
    unavailable: true,
  },
};

const TELEVISIT_CANCEL_TYPE = {
  DISCHARGED: 4,
  TRANSFERRED_TO_OTHER_WARD: 5,
  PATIENT_UNFIX_FOR_TV: 6,
  PATIENT_REFUSE: 7,
  PATIENT_IS_HAVING_MEDICAL_EXAMINATION: 8,
  OTHER: 9,
  // CANCEL_MANUALLY_IN_HA_GO: 10,
  // LOW_BATTERY: 1,
  // ROBOT_UNAVAILABLE_OR_DISCONNECTION: 3,
  // UNEXPECTED_ERROR: 2,
  TECHNICAL_ISSUE: 15,
};

const TELEVISIT_BOOKING_SOURCE = {
  WP: 'WP',
  HAGO: 'HAGO',
};

const TELEVISIT_REGEX = {
  PHONE: /^[4-9]\d{7}$/,
};

// remarks command barcodes field
const REMARKS_FIELD = {
  BIPAP_MASK_SIZE_S: 'Bipap mask size (S)',
  BIPAP_MASK_SIZE_M: 'Bipap mask size (M)',
  BIPAP_MASK_SIZE_L: 'Bipap mask size (L)',
  EXCEPT_ISOLATION_WARD: 'Infection status form available (except isolation ward)',
  START_CODE: 'DWP.COMM.BMS.',
  END_CODE: '.BARCODE.END',
  REPLACE_REMARK_REGEX: /DWP\.COMM\.BMS\..+?\.BARCODE\.END/g,
};

const TAB_STATUS = ['Inactive', 'Active'];

const HYPER_LINK_REGEX = new RegExp(
  process.env.REACT_APP_HYPER_LINK_REGEX,
  process.env.REACT_APP_HYPER_LINK_REGEX_FLAGS
);

const ADS_TYPE = {
  SINGLE: 'Single Equipment',
  MULTIPLE: 'Multiple Equipment',
  MISSING: 'Missing',
  UPDATE_DECLINED: 'Update Declined',
  UPDATE_WITHDRAWN: 'Update Withdrawn',
  REMINDER_DECLINED: 'Reminder Declined',
  REMINDER_WITHDRAWN: 'Reminder Withdrawn',
};

const ADS_LAST_ORDER_STATUS = {
  W: 'EQUIPMENT_ADS_STATUS_WAITING',
  A: 'EQUIPMENT_ADS_STATUS_ASSIGNED',
  R: 'EQUIPMENT_ADS_STATUS_RESPONDED',
  C: 'EQUIPMENT_ADS_STATUS_COMPLETED',
  P: 'EQUIPMENT_ADS_STATUS_PENDING',
  D: 'EQUIPMENT_ADS_STATUS_DELAY',
  S: 'EQUIPMENT_ADS_STATUS_ARRANGE',
  T: 'EQUIPMENT_ADS_STATUS_UNPROCESSED',
  H: 'EQUIPMENT_ADS_STATUS_IMMEDIATE',
  E: 'EQUIPMENT_ADS_STATUS_INCOMPLETE',
  U: 'EQUIPMENT_ADS_STATUS_UNDECIDED',
  F: 'EQUIPMENT_ADS_STATUS_IDENTIFIED',
  J: 'EQUIPMENT_ADS_STATUS_REJECTED',
  G: 'EQUIPMENT_ADS_STATUS_FAXED',
};

const TELEVISIT_DELAY_TYPE = {
  OTHER: 2,
};

// hospital service type
const SERVICE_TYPE = {
  INPATIENT: 'INPATIENT',
  AED: 'AED',
  SOPC: 'SOPC',
  AHC: 'AHC',
  GOPC: 'GOPC',
  OTHERS: 'OTHERS',
};

// order service status 的枚舉
export const ORDER_SERVICE_STATUS_ENUM = {
  W: { text: 'Waiting', color: '#FFEECC' },
  A: { text: 'Assigned', color: '#BAD2FF' },
  R: { text: 'Responded', color: '#BAD2FF' },
  C: { text: 'Completed', color: '#28D2AB' },
  P: { text: 'Pending', color: '#FF8181' },
  D: { text: 'Delay', color: '#6C2AF8' },
  Y: { text: 'Deleted', color: '#6C2AF8' },
  S: { text: 'Arrange', color: '#A9EDDD' },
  T: { text: 'Unprocessed', color: '#6C2AF8' },
  H: { text: 'Immediate', color: '#C30E0B' },
  E: { text: 'Incomplete', color: '#6C2AF8' },
  U: { text: 'Undecided', color: '#6C2AF8' },
  F: { text: 'Identified', color: '#28D2AB' },
  J: { text: 'Rejected', color: '#6C2AF8' },
  G: { text: 'Faxed', color: '#28D2AB' },
};

export {
  LOGIN_INFO,
  WARD_INFO,
  DUTY_INFO,
  IS_LOGIN_ACTION,
  SETTING_TAB_ACTION_ID,
  BEDSTATUS_CHOOSE_FILTER,
  REFRESH_TOKEN_MINUTE,
  IS_TOKEN_ERROR_ALTER,
  USER_CURRENT_LANG,
  SETTING_EDIT_TABLE,
  NOTIFICATION_TAB,
  NOTIFICATION_MESSAGE,
  BEDSTATUS_OUTSTANDING_TRANSFER_IN,
  NOTIFICATION_INTERVAL,
  REQUEST_STATUS_ENUM,
  EQUIPMENT_STATUS_ENUM,
  EQUIPMENT_PIE_STATUS_ENUM,
  EQUIPMENT_REQUEST_DATE_FORMAT,
  EQUIPMENT_LENGTH,
  EQUIPMENT_INTERVAL,
  SERVICE,
  BOOKING_DETAILS,
  TELEVISIT_STATUS,
  TELEVISIT_STYLE,
  TELEVISIT_ROBOT_STATUS,
  TELEVISIT_CANCEL_TYPE,
  TELEVISIT_DELAY_TYPE,
  TELEVISIT_BOOKING_SOURCE,
  TAB_STATUS,
  TELEVISIT_REGEX,
  REMARKS_FIELD,
  HYPER_LINK_REGEX,
  ADS_TYPE,
  ADS_LAST_ORDER_STATUS,
  CHECK_TOKEN_EXPIRY_INTERVAL,
  APPRECIATION_INTERVAL,
  SERVICE_TYPE,
};

export const BS_TOOLBAR_STATUS = {
  MOVE: 'move',
  MOUSE: 'mouse',
};

export const NEW_BED_STATUS_LENGTH = {
  CUBICLE_NAME: 20,
  CUBICLE_TYPE: 20,
  CUBICLE_STATUS: 15,
  CUBICLE_REMARKS: 100,
  LINKED_BED_NAME: 8,
  WARD_LOCATION_REMARKS: 250,
  MEMO_REMARKS: 1000,
};

export const NEW_BED_STATUS_CUBICLE_ITEM_LIST = {
  CubicleType: [
    {
      text: 'AIIR',
      value: 'AIIR',
    },
    {
      text: 'Airborne Isolation',
      value: 'Airborne Isolation',
    },
    {
      text: 'Clean',
      value: 'Clean',
    },
    {
      text: 'Contact Isolation',
      value: 'Contact Isolation',
    },
    {
      text: 'CPE',
      value: 'CPE',
    },
    {
      text: 'Droplet Isolation',
      value: 'Droplet Isolation',
    },
    {
      text: 'EOL',
      value: 'EOL',
    },
    {
      text: 'HFOT',
      value: 'HFOT',
    },
    {
      text: 'ICEC',
      value: 'ICEC',
    },
    {
      text: 'Isolation',
      value: 'Isolation',
    },
    {
      text: 'MDROs',
      value: 'MDROs',
    },
    {
      text: 'MRSA Cohort',
      value: 'MRSA Cohort',
    },
    {
      text: 'NIV',
      value: 'NIV',
    },
    {
      text: 'Protective Isolation',
      value: 'Protective Isolation',
    },
    {
      text: 'Reverse Isolation',
      value: 'Reverse Isolation',
    },
    {
      text: 'Single Room',
      value: 'Single Room',
    },
    {
      text: 'Surveillance Cubicle',
      value: 'Surveillance Cubicle',
    },
    {
      text: 'Surveillance Room',
      value: 'Surveillance Room',
    },
    {
      text: 'Uni-dir. Flow Room',
      value: 'Uni-dir. Flow Room',
    },
    {
      text: 'VRE',
      value: 'VRE',
    },
  ],
  CubicleStatus: [
    {
      text: 'Disinfection',
      value: 'Disinfection',
    },
    {
      text: 'Frozen',
      value: 'Frozen',
    },
    {
      text: 'In-use',
      value: 'In-use',
    },
    {
      text: 'Maintenance',
      value: 'Maintenance',
    },
    {
      text: 'Overhaul',
      value: 'Overhaul',
    },
  ],
  Gender: [
    { text: 'M', value: 'M' },
    { text: 'F', value: 'F' },
    { text: 'X', value: 'X' },
  ],
  CubicleColor: [
    {
      text: 'Blue',
      value: 'Blue',
      color: '#ebf3ff',
    },
    {
      text: 'Pink',
      value: 'Pink',
      color: '#ffefef',
    },
    {
      text: 'Purple',
      value: 'Purple',
      color: '#f7f3ff',
    },
    {
      text: 'Yellow',
      value: 'Yellow',
      color: '#fff9eb',
    },
    {
      text: 'Grey',
      value: 'Grey',
      color: '#f6f6f6',
    },
    {
      text: 'Green',
      value: 'Green',
      color: '#e0ffe5',
    },
    {
      text: 'White',
      value: 'White',
      color: '#ffffff',
    },
  ],
  RemarkColor: [
    {
      text: 'White',
      value: 'White',
      color: '#fff',
    },
    {
      text: 'Blue',
      value: 'Blue',
      color: '#bad2ff',
    },
    {
      text: 'Purple',
      value: 'Purple',
      color: '#decfff',
    },
    {
      text: 'Green',
      value: 'Green',
      color: '#a9eddd',
    },
    {
      text: 'Yellow',
      value: 'Yellow',
      color: '#fbefb7',
    },
    {
      text: 'Maganta',
      value: 'Maganta',
      color: '#ffd8e3',
    },
  ],
  Cubicle: [
    {
      text: 'Cubicle',
      value: 'Cubicle',
    },
    {
      text: 'Nurse Station/Misc.',
      value: 'Nurse Station/Misc.',
    },
    {
      text: 'Memo',
      value: 'Memo',
    },
  ],
};

export const BED_STATUS_CUBICLE_COLOR = {
  Blue: '#ebf3ff',
  Pink: '#ffefef',
  Purple: '#f7f3ff',
  Yellow: '#fff9eb',
  Grey: '#f6f6f6',
  Green: '#e0ffe5',
  White: '#ffffff',
  Red: 'rgb(250,138,130)',
  Orange: 'rgb(255,192,0)',
};

export const BED_STATUS_REMARK_COLOR = {
  White: {
    leftColor: '#e4e7eb',
    bgColor: '#fff',
    color: '#2e4469',
  },
  Blue: {
    leftColor: '#1a6aff',
    bgColor: '#bad2ff',
    color: '#1a6aff',
  },
  Purple: {
    leftColor: '#6c2af8',
    bgColor: '#decfff',
    color: '#6c2af8',
  },
  Green: {
    leftColor: '#28d2ab',
    bgColor: '#a9eddd',
    color: '#1f846d',
  },
  Yellow: {
    leftColor: '#f3d545',
    bgColor: '#fbefb7',
    color: '#7F6B06',
  },
  Maganta: {
    leftColor: '#ff50a4',
    bgColor: '#ffd8e3',
    color: '#ff50a4',
  },
};

export const LEAD = {
  TOMORROW: -1,
  TODAY: 0,
  YESTERDAY: 1,
  BEFORE_YESTERDAY: 2,
};

export const GENDER = [
  {
    text: 'M',
    value: 'M',
  },
  {
    text: 'F',
    value: 'F',
  },
];

export const WT = [
  {
    text: 'Full List',
    value: '0',
  },
  {
    text: '>2hrs',
    value: '2',
  },
  {
    text: '>4hrs',
    value: '4',
  },
  {
    text: '>8hrs',
    value: '8',
  },
  {
    text: '>12hrs',
    value: '12',
  },
  {
    text: '>24hrs',
    value: '24',
  },
  {
    text: '>36hrs',
    value: '36',
  },
  {
    text: '>48hrs',
    value: '48',
  },
];

export const ADMISSION_SETTING_MAPPING = {
  PWAS: 'Pending for Ward Assigned',
  PWA: 'Pending for Ward Acknowledged',
  PWR: 'Pending for Ward Ready',
  WAS: 'Ward Assigned',
  WA: 'Ward Acknowledged',
  WR: 'Ward Ready',
  DCAR: 'AED Discharged for Adm. Reg.',
  ARC: 'Adm. Reg. Completed',
  RU: 'Remark or Special Alert Updated',
  SU: 'Specialty Updated for assigned case',
  W: 'Withdrawn for assigned case',
  PFYA: 'Pending for T/I Accepted',
  ATO: 'Accepted T/O',
  RTO: 'Rejected T/O',
  MAA: 'Multiple action alert',
  PDWR: 'Pending for Ward Ready T/I',
  RECVWR: 'Recv. Ward Ready T/I',
  PWAT: 'Pending for Ward Assign T/I',
};

export const ACTIONABLE_TICKET_MAPPING = {
  PWAS: {
    bgColor: '#FA8A82',
    color: '#FFF',
  },
  PWA: {
    bgColor: '#FECA06',
    color: '#FFF',
  },
  PWR: {
    bgColor: '#F4FF72',
    color: '#333',
  },
  WAS: {
    bgColor: '#FA8A82',
    color: '#FFF',
  },
  WA: {
    bgColor: '#F4FF72',
    color: '#333',
  },
  WR: {
    bgColor: '#F4FF72',
    color: '#333',
  },
  RECVWR: {
    bgColor: '#F4FF72',
    color: '#333',
  },
  PDWR: {
    bgColor: '#F4FF72',
    color: '#333',
  },
  DCAR: {
    bgColor: '#34C759',
    color: '#FFF',
  },
  ARC: {
    bgColor: '#34C759',
    color: '#FFF',
  },
  RU: {
    bgColor: '#4C93FF',
    color: '#FFF',
  },
  SU: {
    bgColor: '#6C2AF8',
    color: '#FFF',
  },
  W: {
    bgColor: '#767576',
    color: '#FFF',
  },
  PFYA: {
    bgColor: '#B795FF',
    color: '#FFF',
  },
  ATO: {
    bgColor: '#AC49DA',
    color: '#FFF',
  },
  RTO: {
    bgColor: '#AC49DA',
    color: '#FFF',
  },
  PWAT: {
    bgColor: '#FA8A82',
    color: '#FFF',
  },
};

// eadmission的6个tab的value
export const E_ADMISSION_TAB_VALUES = {
  Pending: 'PD',
  Completed: 'C',
  Actionable: 'Actionable',
  AEDView: 'AED_VIEW',
  SOPDView: 'SOPD_VIEW',
  TransferInPending: 'TI_PD',
  TransferInCompleted: 'TI_C',
};

export const E_ADMISSION_GRID_SIMENSIONS = {
  width: '20.643rem',
  height: '5.143rem',
};

export const TV_DASHBOARD_COLOR_ENUM = [
  {
    title: 'Default',
    dropDownColor: '#F5FAFF',
    borderColor: '#538FFF',
    bgColor: '#F5FAFF',
    dropDownBorderColor: '1px solid #969696',
  },
  {
    title: 'Pink',
    dropDownColor: '#FF97B6',
    borderColor: '#F54C9D',
    bgColor: '#FFD8E3',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Coral Pink',
    dropDownColor: '#FA8A82',
    borderColor: '#FF8356',
    bgColor: '#FFDFCF',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Orange',
    dropDownColor: '#FECA06',
    borderColor: '#DAB609',
    bgColor: '#FBEFB7',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Yellow',
    dropDownColor: '#F4FF72',
    borderColor: '#C6D519',
    bgColor: '#FAFFC3',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Grass Green',
    dropDownColor: '#34C759',
    borderColor: '#34C759',
    bgColor: '#E5FFEC',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Green',
    dropDownColor: '#00AC84',
    borderColor: '#00AC84',
    bgColor: '#BEFFDB',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Blue',
    dropDownColor: '#4C93FF',
    borderColor: '#4C93FF',
    bgColor: '#B2F4FF',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Lavender',
    dropDownColor: '#B795FF',
    borderColor: '#B795FF',
    bgColor: '#FAF7FF',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Purple',
    dropDownColor: '#AC49DA',
    borderColor: '#AC49DA',
    bgColor: '#F5DFFF',
    dropDownBorderColor: 'unset',
  },
  {
    title: 'Indigo',
    dropDownColor: '#6C2AF8',
    borderColor: '#6C2AF8',
    bgColor: '#E0D1FF',
    dropDownBorderColor: 'unset',
  },
];

export const OTH_OTHERS_ID = 9;
export const SF_CLINIC = 'Clinic';
export const HAHO = 'HAHO';
export const CFA_TYPE_APPRECIATION = 'Appreciation';
